import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageReloadAlert = lazy(() => import('.'))

class PageReloadAlertComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['is-editor-open']
	}

	override render() {
		const isEditorOpen = this.prop('is-editor-open') === 'true'

		return <PageReloadAlert condition={isEditorOpen} />
	}
}

customElements.define('page-reload-alert', PageReloadAlertComponent)
